if (location.protocol === 'http:' && /shopping\.friday\.tw/i.test(location.host)) {
  location.href = location.href.replace('http:', 'https:')
}

import Vue from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueYoutube from 'vue-youtube-embed'
import configs from './config/configs.js'
import storage from './utils/storage.js'
import ga from './utils/ga.js'
import ec from './utils/ec.js'
import mock from './utils/mock.js'
import tools from './utils/tools.js'

Vue.config.productionTip = false

// export configs
Vue.prototype.configs = configs
Vue.prototype.storage = storage
Vue.prototype.ec = ec
Vue.prototype.ga = ga
Vue.prototype.mock = mock
Vue.prototype.tools = tools
Vue.prototype.isMobile = /mobi(le)?/i.test(navigator.userAgent)
Vue.prototype.fridayMessage = window.fridayComponent.Message

// axios default setting
axios.defaults.baseURL = configs.apiPath()

Vue.use(VueYoutube)
Vue.use(VueAxios, axios)

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
